import { Box, Grid } from "@mui/material";
import styles from "./styles.module.css";
import HlsVideoPlayer from "../../../components/home/HlsVideoPlayer";
function LiveVideo({ result }) {

  //
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {result.map((item) => (
            <Grid item xs={12} sm={6}>
              <div className={styles.liveCard}>
                <HlsVideoPlayer
                  hlsUrl={`https://localpratham.app-assertai.com/HLS/${item._id}/playlist.m3u8`}
                />
              <div style={{ fontWeight: "600" }}>{item.videoId?.title}</div>
              </div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
}

export default LiveVideo;
